import { Component, OnInit } from '@angular/core';
import { BasePageComponent } from '@carm/_utils/base-page.component';

@Component({
  selector: 'carm-offsetting-terms',
  templateUrl: './offsetting-terms.component.html',
  styleUrls: ['./offsetting-terms.component.scss']
})
export class OffsettingTermsComponent extends BasePageComponent implements OnInit {
  
  public termsAndConditions = this.translateService.instant('components.confirmTermsDialog.offsetting');

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
